module.exports = __webpack_public_path__ + "static/media/TAGELUS.d5bd35cb.jpg";